(() => {
    const selectors = {
        root: '[data-free-shipping-progress]',
        text: '.free-shipping__text',
        fill: '.free-shipping__fill',
        bar: '.free-shipping__bar',
    };

    const formatGBP = (pence) => {
        // Shopify totals are in cents/pence
        const pounds = (pence / 100);
        return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(pounds);
    };

    const updateAll = async () => {
        const roots = document.querySelectorAll(selectors.root);
        if (!roots.length) return;

        let cart;
        try {
            cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
        } catch (e) {
            return;
        }

        // Choose the same basis you used in Liquid:
        const cartValue = cart.items_subtotal_price; // or cart.total_price

        roots.forEach((root) => {
            const threshold = Number(root.dataset.threshold || 0);
            if (!threshold) return;

            const remaining = Math.max(threshold - cartValue, 0);
            const percent = Math.min(Math.max(Math.round((cartValue / threshold) * 100), 0), 100);

            const textEl = root.querySelector(selectors.text);
            const fillEl = root.querySelector(selectors.fill);
            const barEl = root.querySelector(selectors.bar);

            if (textEl) {
                textEl.innerHTML = remaining > 0
                    ? `Spend <strong>${formatGBP(remaining)}</strong> more to unlock <strong>FREE shipping</strong>.`
                    : `🎉 You’ve unlocked <strong>FREE shipping</strong>.`;
            }

            if (fillEl) fillEl.style.width = `${percent}%`;
            if (barEl) barEl.setAttribute('aria-valuenow', String(percent));
        });
    };

    // Run on load
    document.addEventListener('DOMContentLoaded', updateAll);

    // Run after common cart operations (covers most themes)
    ['cart:updated', 'cart:refresh', 'cart:change', 'product:added'].forEach((evt) => {
        document.addEventListener(evt, updateAll);
    });

    // Fallback: update whenever drawer opens / DOM changes
    const mo = new MutationObserver(() => updateAll());
    mo.observe(document.documentElement, { childList: true, subtree: true });
})();
